export default "__VITE_ASSET__DWDtapF4__"